export enum ManagerIntegrationSort {
  integrationId = 'sort[integration][id]',
  alias = 'sort[integration][alias]',
  label = 'sort[integration][label]',
}

export enum ManagerIntegrationFilters {
  integrationId = 'filters[integration][id]',
  alias = 'filters[integration][alias]',
  search = 'search',
}
